import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M3 2C2.449 2 2 2.449 2 3V11.586L3.293 10.293C3.48 10.105 3.735 10 4 10H12.002C12.554 10 13.002 9.551 13.002 9V3C13.002 2.449 12.554 2 12.002 2H3ZM1 15C0.871 15 0.741 14.975 0.617 14.924C0.244 14.769 0 14.404 0 14V3C0 1.346 1.346 0 3 0H12.002C13.657 0 15.002 1.346 15.002 3V9C15.002 10.654 13.657 12 12.002 12H4.414L1.707 14.707C1.516 14.898 1.26 15 1 15Z",
  "M17 18C16.74 18 16.484 17.898 16.293 17.707L13.586 15H6.002C5.45 15 5.002 14.552 5.002 14C5.002 13.448 5.45 13 6.002 13H14C14.265 13 14.519 13.105 14.707 13.293L16 14.586V7.002C16 6.45 16.448 6.002 17 6.002C17.552 6.002 18 6.45 18 7.002V17C18 17.404 17.756 17.769 17.383 17.924C17.259 17.975 17.129 18 17 18Z",
];

export function MessagesIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
